import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAuthVector = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 690,
	height: 274,
	viewBox: "0 0 690 274",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30.3338 16.5644C-28.0159 -13.0488 -69.1586 6.07483 -69.1586 6.07483L-80.7153 579.249L692.866 542.802V270.395C692.866 270.395 621.415 189.159 470.088 218.759C300.122 252.005 226.361 199.56 151.718 120.747C113.553 80.4506 88.6837 46.1776 30.3338 16.5644Z",
		fill: "white"
	})
});
export default SvgAuthVector;
